import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Typography } from 'antd';

const { Title, Text } = Typography;

class CommentsList extends Component {
  createComment = (comment) => (
    <Row key={comment.commentId}>
      <Col body>
        <Row type="flex" justify="space-between">
          <Title level={4}>{comment.userName}</Title>
          <Text>{comment.createdAt}</Text>
        </Row>
        <Text className="mb-0">{comment.content}</Text>
      </Col>
    </Row>
  );

  createList = () => {
    return (
      <div className="mb-2">
        {this.props.comments.map((c) => this.createComment(c))}
      </div>
    );
  };

  createPlaceholder = () => (
    <div className="mb-2">
      <h3>No Comments</h3>
    </div>
  );

  render() {
    return this.props.comments.length !== 0
      ? this.createList()
      : this.createPlaceholder();
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(CommentsList);
